// eslint-disable-next-line import/no-cycle
import { TValidTestId } from 'types/context-role-element.types';
import AuthContext from './contexts/auth';
import CartContext from './contexts/cart';
import DeliveryContext from './contexts/cart/delivery';
import PaymentContext from './contexts/cart/payment';
import CommonContext from './contexts/common';
import GeneralContext from './contexts/general';
import HomeContext from './contexts/home';
import ListingPageContext from './contexts/listing-page';
import ProductPageContext from './contexts/product/product-page';
import SectionBlogContext from './contexts/section-blog';

export const VALID_TEST_ID = {
  ...HomeContext,
  ...SectionBlogContext,
  ...AuthContext,
  ...CartContext,
  ...DeliveryContext,
  ...PaymentContext,
  ...CommonContext,
  ...ListingPageContext,
  ...ProductPageContext,
  ...GeneralContext,
} as TValidTestId;
